import React, { useMemo } from 'react';
import './styles.css';
import { X, Check } from 'lucide-react';
import * as Diff from 'diff';
import { useTranslation } from 'react-i18next';

interface PolishDialogProps {
  originalContent: string;
  polishedContent: string;
  isPolishing: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

const PolishDialog: React.FC<PolishDialogProps> = ({
  originalContent,
  polishedContent,
  isPolishing,
  onAccept,
  onCancel
}) => {
  const { t } = useTranslation('polish');

  const diffResult = useMemo(() => {
    if (!polishedContent) return [];
    return Diff.diffWords(originalContent, polishedContent);
  }, [originalContent, polishedContent]);

  return (
    <div className="polish-dialog-overlay">
      <div className="polish-dialog">
        <div className="polish-dialog-content">
          <div className="polish-text-container">
            <div className="polish-text diff">
              <div className="polish-label">
                {t('text_comparison')}
                {isPolishing && <span className="polishing-indicator">{t('polishing')}</span>}
              </div>
              <div className="polish-content">
                {diffResult.map((part, index) => (
                  <span
                    key={index}
                    className={
                      part.added ? 'diff-added' :
                      part.removed ? 'diff-removed' :
                      'diff-unchanged'
                    }
                  >
                    {part.value}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="polish-dialog-actions">
            <button 
              className="polish-button accept" 
              onClick={onAccept}
              disabled={isPolishing}
            >
              <Check size={16} />
              {t('accept')}
            </button>
            <button className="polish-button cancel" onClick={onCancel}>
              <X size={16} />
              {t('cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolishDialog; 